// extracted by mini-css-extract-plugin
module.exports = {"pageWrap":"ka-z","heading":"la-z","screenReadersOnly":"ma-z"};